export default "__VITE_ASSET__a34917e6__"